import React, { useEffect, useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CustomButton from '../CustomButton'
import SectionHeader from '../sectionHeader'
import SectionSubHeader from '../sectionSubHeader'
import Header from '../../layouts/Header'
import Footer from '../../layouts/Footer'

const CommonDesign = ({data = {}}) => {
   
  return (
    <div className='service'>
     
        <div className="service-info">
    <Container className="" >
    <SectionHeader mainText1={data.service_name}  />
      <Row>
        <Col lg={6}>
         
          <SectionSubHeader headerText={data.title} />
         
        </Col>
        <Col lg={6} > 
        <p>{data.content}</p>
        </Col>
      </Row>
    </Container>
     
  </div>
    </div>
  )
}

export default CommonDesign;
